import { environment } from '../../../environments/environment';
var StorageLinkPipe = /** @class */ (function () {
    function StorageLinkPipe() {
    }
    Object.defineProperty(StorageLinkPipe, "PARTS", {
        get: function () {
            return [environment.backend, 'storage'];
        },
        enumerable: true,
        configurable: true
    });
    StorageLinkPipe.prototype.transform = function (path, subFolder) {
        if (!path) {
            return null;
        }
        var parts = StorageLinkPipe.PARTS;
        subFolder && parts.push(subFolder);
        parts.push(path);
        return parts.join('/');
    };
    return StorageLinkPipe;
}());
export { StorageLinkPipe };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/storage-link/storage-link.pipe.ts.pre-build-optimizer.js